import styled from '@emotion/styled'

import { ButtonLink } from '@/components/Button'
import { Media, type MediaProps } from '@/components/Media'
import { BodyM } from '@/components/Typography'
import { decodeURL } from '@/core/utils/dom/decodeURL'

export interface NewsItemProps {
  title: {
    text: string
    tag?: string
  }
  description: string
  midia: MediaProps
  button?: {
    label?: string
    action?: {
      value?: string
    }
  }
  width?: number
  height?: number
}

const NewsItemStyles = styled.div({
  position: 'relative',
  maxWidth: '80%',
  minWidth: '18.7rem',
  minHeight: '24rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: 'var(--radii-default)',
  backgroundColor: 'rgba(var(--theme-snow))',
  boxShadow: '0 4px 9px 0 rgba(var(--theme-black), 0.1)',
  border: 'solid 1px #ececec',
  padding: '1rem 1.5rem 6rem 1.5rem',
  margin: 'var(--space-1) auto var(--space-2)',

  '& .cover': {
    position: 'relative',
    width: '7.5rem',
    height: '5rem',
    overflow: 'hidden',
    border: 'solid 1px rgba(var(--theme-palegray))',
    borderRadius: 'var(--radii-default)',
    marginBottom: 'var(--space-2)',
    boxSizing: 'unset',
  },

  '& .button': {
    position: 'absolute',
    left: '1.5rem',
    right: '1.5rem',
    bottom: '1.5rem',
  },
})

const NewsItem = ({
  midia: medusaMidiaProps,
  width = 120,
  height = 80,
  title,
  description,
  button,
}: NewsItemProps) => (
  <NewsItemStyles>
    <div className="cover">
      <Media
        width={width}
        height={height}
        layout="responsive"
        aspectRatio="16x9"
        {...medusaMidiaProps}
      />
    </div>

    <BodyM tag={title.tag || 'p'} dark="medium" className="eu-sm-1" emphasys>
      {title.text}
    </BodyM>

    <BodyM tag="div" className="et-ta-center" dark="medium" html={description} />

    {button && button.action && button.action.value && (
      <ButtonLink
        modifier="outline"
        source={decodeURL(button.action.value)}
        size="lg"
        className="button et-ta-center"
      >
        {button.label || 'Acessar'}
      </ButtonLink>
    )}
  </NewsItemStyles>
)

export default NewsItem
